import { gql } from '@apollo/client';

export const FETCH_APP_DATA = gql`
    query FetchAppData($lng: String) {
        glassesPackages(company: PBE, glassesType: SUN, lng: $lng) {
            id
            name
            default
            multifocal
            borderless
            backgroundColorGeneral
            textColorGeneral
            priceInt
            canBeOrdered
            order
            topChoice
            featureIds
            strength
            readingArea
            addOns {
                id
                name
                description
                order
                priceInt
                excludesAddOnIds
                freeWithPackagesIds
            }
        }
        features(company: PBE, glassesType: SUN, lng: $lng) {
            id
            name
            order
        }
    }
`;
